/*
 * AmbientStarfield — 30 twinkling stars + purple pulse blob.
 * Used by the onboarding welcome / closing screens as full-page backdrop.
 */
import React, { useMemo } from "react";
import "./AmbientStarfield.css";

export const AmbientStarfield = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 30 }, (_, i) => ({
        x: Math.round((i * 37) % 100 + (i % 7) * 3),
        y: Math.round((i * 53) % 100),
        size: 1 + (i % 3),
        dur: 2 + (i % 4),
        delay: (i * 0.13).toFixed(2),
      })),
    []
  );

  return (
    <div className="asf-root" aria-hidden data-testid="ambient-starfield">
      {stars.map((s, i) => (
        <div
          key={i}
          className="asf-star"
          style={{
            left: `${s.x}%`,
            top: `${s.y}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.dur}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
      <div className="asf-pulse" />
    </div>
  );
};

export default AmbientStarfield;
